'use client'

import { createContext, useContext, useRef } from 'react'
import { useStore as _useStore } from 'zustand'

import { createStore } from '../store'
import type { ReactNode } from 'react'
import type { Store } from '../store'

export type StoreApi = ReturnType<typeof createStore>

export const StoreContext = createContext<StoreApi | undefined>(undefined)

export const useStore = <T,>(selector: (store: Store) => T): T => {
  const storeContext = useContext(StoreContext)

  if (!storeContext) {
    throw new Error(`_useStore must be used within StoreProvider`)
  }

  return _useStore(storeContext, selector)
}

export interface StoreProviderProps {
  children: ReactNode
}

export const StoreProvider = ({ children }: StoreProviderProps) => {
  const storeRef = useRef<StoreApi>(null)
  if (!storeRef.current) {
    storeRef.current = createStore()
  }

  return (
    <StoreContext.Provider value={storeRef.current}>
      {children}
    </StoreContext.Provider>
  )
}
